export enum CheckType {
  CheckIn = 'checkIn',
  CheckOut = 'checkOut'
}
